import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/portfolio1.jpg'
import IMG2 from '../../assets/portfolio2.jpg'
import IMG3 from '../../assets/portfolio3.jpg'
import IMG4 from '../../assets/portfolio4.jpg'
import IMG5 from '../../assets/portfolio5.png'
import IMG6 from '../../assets/portfolio6.jpg'

// DO NOT USE THE IMAGES IN PRODUCTION

const data = [
  {
    id: 1,
    image: IMG1,
    title: 'Online Android Quiz Application',
    description: 'Android app that retrieves questions from a database with Google Sign-In authentication and real-time scoring.',
    github: 'https://github.com/SliimmAA/android-quiz',
    demo: 'https://github.com/SliimmAA/android-quiz',
    technologies: ['Android Studio', 'Firebase', 'Java', 'Google Auth']
  },
  {
    id: 2,
    image: IMG2,
    title: 'Cloud-based Car Maintenance System',
    description: 'Comprehensive vehicle maintenance tracking system built with cloud architecture and real-time notifications.',
    github: 'https://github.com/SliimmAA/car-maintenance-system',
    demo: 'https://github.com/SliimmAA/car-maintenance-system',
    technologies: ['Azure Cloud', 'C#', 'SQL Database', 'REST APIs']
  },
  {
    id: 3,
    image: IMG3,
    title: 'Movolytics Fleet Management',
    description: 'Professional fleet management system with CSV upload functionality, latitude/longitude integration, and postcode tracking.',
    github: 'https://github.com/movolytics/fleet-management',
    demo: 'https://movolytics.com',
    technologies: ['React', 'Node.js', 'SQL', 'Azure DevOps', 'CSV Processing']
  },
  {
    id: 4,
    image: IMG4,
    title: 'Real-time Chat Application',
    description: 'Modern messaging platform with real-time communication, user authentication, and responsive design.',
    github: 'https://github.com/SliimmAA/realtime-chat',
    demo: 'https://sliimmaa.github.io/realtime-chat/',
    technologies: ['React', 'Socket.io', 'Node.js', 'MongoDB']
  },
  {
    id: 5,
    image: IMG5,
    title: 'University Lab Management System',
    description: 'Educational platform for managing computer lab sessions, student progress tracking, and course content delivery.',
    github: 'https://github.com/SliimmAA/lab-management',
    demo: 'https://github.com/SliimmAA/lab-management',
    technologies: ['Java', 'Spring Boot', 'MySQL', 'Educational Tech']
  },
  {
    id: 6,
    image: IMG6,
    title: 'Microsoft Azure Cloud Solutions',
    description: 'Cloud infrastructure projects showcasing Azure services implementation and DevOps best practices.',
    github: 'https://github.com/SliimmAA/azure-solutions',
    demo: 'https://github.com/SliimmAA/azure-solutions',
    technologies: ['Azure Cloud', 'DevOps', 'CI/CD', 'PowerShell']
  }
]


const Portfolio = () => {
  return (
    <section id='portfolio'>
      {/* Floating Background Elements */}
      <div className="portfolio__floating-element"></div>
      <div className="portfolio__floating-element"></div>
      
      {/* Section Header */}
      <div className="portfolio__header">
        <span className="portfolio__badge">Recent Projects</span>
        <h2 className="portfolio__main-title">My Portfolio</h2>
        <p className="portfolio__subtitle">
          Explore my latest projects showcasing modern web development, 
          creative problem-solving, and attention to detail in every build.
        </p>
      </div>

      <div className="container portfolio__container">
        {
          data.map(({id, image, title, description, github, demo, technologies}) => {
            return (
              <article key={id} className='portfolio__item'>
                <div className="portfolio__item-image">
                  <img src={image} alt={title} />
                  <div className="portfolio__item-overlay">
                    <div className="portfolio__item-preview">
                      <span>👁 View Project</span>
                    </div>
                  </div>
                </div>
                <div className="portfolio__item-content">
                  <div className="portfolio__item-header">
                    <h3>{title}</h3>
                    <div className="portfolio__item-status">
                      <span className="status-dot active"></span>
                      <span>Live</span>
                    </div>
                  </div>
                  <p className="portfolio__item-description">{description}</p>
                  
                  {/* Technologies Section */}
                  <div className="portfolio__technologies">
                    <span className="tech-label">Built with:</span>
                    <div className="tech-stack">
                      {technologies.map((tech, index) => (
                        <span key={index} className="tech-badge">
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="portfolio__item-cta">
                    <a href={github} className='btn btn-outline' target='_blank' rel="noopener noreferrer">
                      <span>📄</span>
                      View Code
                    </a>
                    <a href={demo} className='btn btn-primary' target='_blank' rel="noopener noreferrer">
                      <span>🚀</span>
                      Live Demo
                    </a>
                  </div>
                </div>
              </article>
            )
          })
        }
      </div>
    </section>
  )
}

export default Portfolio